<template>
    <div class="os_gw_info">
        <div class="load_info" v-if="!is_load">
            <button class="btn btn-primary" type="button" disabled="">
                <span class="spinner-border spinner-border-sm"></span>
            </button>
        </div>

        <div class="info" v-else>
            <div class="gw_info" v-if="obj_to_null(gw_item)">
                <div class="cursor-pointer btn btn-micro border bg-success active color-white " v-if="parseInt(gw_item.card_count) > 0">
                    <span aria-hidden="true" class="fal fa-sd-card "></span>
                </div>

                <div class="cursor-pointer btn btn-micro border bg-warning active color-white "  v-else>
                    <span aria-hidden="true" class="fal fa-sd-card "></span>
                </div>

            </div>
            <div class="gw_empty" v-else>
                <div class="cursor-deny btn btn-micro border bg-danger  active color-white ">
                    <span aria-hidden="true" class=" fal fa-user-alt-slash"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    name: "gw_os_uprox",
    props : {
        id : {
            type : Number,
            required : true
        },
    },

    data() {
        return {
            is_load : false,
          
        }
    },

    created () {
        EventBus.$on('uprx_count_ready',this.work_data)
    },

    methods: {
        
        work_data() {
            this.is_load = true;
        },
        
        async getOsUprox() {
         
         /*   let os_ids = [];
            os_ids.push(this.os_id);
            await api.post('/uprox/users',{
                "os_ids": os_ids,
                'user_atr' : [
                    'cards'
                ]
                
            }).then(({data}) => {
                this.is_load = true;
                if(data.status == "operation_success") {
                    this.gw_item = data.data[0];
                }
                else {
                    this.gw_item = {};
                }
            }).catch(err => {
                this.gw_item = {};
                this.is_load = true;
                EventBus.$emit('show_toast', {err:err.message + "OS_ID:".this.id ,type:"danger",title:err.name})
            });*/
        },
    },
    
    computed : {
        
        ...mapGetters({
            'uprox_users': "uprox_status/items",
        }),
        
        
        gw_item () {
            let item = {
                "id" : this.id,
                'card_count' : 0
            };
            
            if(this.uprox_users.length > 0) {
                this.uprox_users.map(os => {
                    if(os.hasOwnProperty('os_id')) {
                        if(os.os_id === this.id) {
                            item = os;
                        }
                    }
                });
            }
            
            return item;
        },
    }
    
}
</script>

<style scoped>

</style>
